export default "__VITE_ASSET__D$BYTdWp__"